<template>
  <q-btn-toggle
      class="tripper"
      style="width: 100%;display: flow"
      v-model="content"
      :options="tripOptions"
      toggle-color="select"
      :class="{'bg-red-4':$route.params.trips=='DEP','bg-orange-4':$route.params.trips=='ARV','bg-teal-6':!['ARV','DEP'].includes($route.params.trips)}"
      xtoggle-text-color="themeCtx=='dark'?'blue':'white'"
      :dark="themeCtx=='dark'"

  />
</template>
<script>
export default {
  name: 'TripTypeSelector',
  props: {
    value: null,
    singleTrips: {type: Boolean, default: false},
  },
  computed: {
    content: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
  },
  mounted() {
    if (this.singleTrips !== false)
      this.tripOptions.splice(2, 1)
  },
  data() {
    return {
      tripOptions: [{
        value: 'DEP',
        // label: 'DEP',
        title: 'Departures',
        icon: 'flight_takeoff',
        color: 'red-6'
      },
        {

          value: 'ARV',
          color: 'orange-6',
          // label: 'ARV',
          icon: 'flight_land'
        },
        {
          color: 'teal-6',
          // label: 'ARV+DEP',
          value: 'ARV,DEP',
          icon: 'flight'
        },
        {
          value: 'EXCRS',
          // label: 'EXCRS',
          icon: 'kayaking',
          color: 'teal-6'
        },
        {
          value: 'PICKUP',
          // label: 'PkP',
          icon: 'airport_shuttle',
          color: 'teal-6'
        }
      ],
      invDialog: false,
      moveMode: false,
      printData: null,
      printReady: false,
      loaded: false,
      timelineView: false,
      errors: null,
      errorDialog: false,
      page: 1,
      buzy: false,
      dbgIssue: null,
      // search: null,
      tripselect: null,
      // distributor_select:null,
      clock: 0,
      // bookingRange: [],

      cols: {},
      dateFormat: "DD/MM/YY",
    };
  },
}
</script>
<style>
.bg-select {

  font-size: 1.1em;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.7);
  border: 1px solid rgba(0, 0, 0, 0.8);
}

tr.el-table__row.drop-row td {
  border: 1px dotted;
}

.bg-select.text-white span.q-btn__content {
  //color: #1a8091;
  font-size: 1.1em;
}

.dark .bg-select.text-white span.q-btn__content {
  //color: #aee0e8;
  font-size: 1.1em;
}
</style>